import { urlBuilder } from '../../../Shared/urlBuilder';
import { NavLink } from '../nav-link/NavLink';

export const HomeLink = () => (
  <NavLink to={urlBuilder.appHome()}>
    <NavLink.Icon name="Home" />
    <NavLink.Text>Home</NavLink.Text>
  </NavLink>
);
